var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTextUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 312,
  height: 29,
  fill: "none",
  viewBox: "0 0 312 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#07F",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M3 15.957s268.5-6.263 306.5-3.763"
})));
export { SvgTextUnderline as ReactComponent };